import moment from 'moment';
import React from 'react';

function AutoField({ component }) {
    const getValue = (type, value) => {
        let val = ''
        switch(type) {
        case 'Date': val  = moment(value).format('Do MMM, YYYY')
            break;
        case 'Time': val  = moment(value).format('hh:mm A')
            break;
        case 'Date and Time': val = moment(value).format('Do MMM YYYY, hh:mm A')
            break;
        }
        return val
    }
    return (
        <div data-testid="auto-field" className={`${component?.label?.alignment === 'top' ? 'flex flex-col' : component?.label?.alignment === 'right' ? 'flex flex-row-reverse items-center' :
            component?.label?.alignment === 'bottom' ? 'flex flex-col-reverse text-center mt-1' : 'flex items-center'} cursor-default`}>
            {component?.label?.name.trim() !== '' && 
            <label className={`
            ${component?.label?.alignment === 'right' ? 'ml-2 max-w-[150px]' : ''} pr-2 break-words`} style={{...component?.label?.styles, overflowWrap: 'anywhere'}}>
                {component.label.name || ''} {component?.is_required && <span data-testid="is_required" className='text-[#333]'>*</span>}
            </label>}
            <input
                id={component.id}
                disabled
                value={component.value ? getValue(component.auto_field_type, component.value) : ''}
                className={`cursor-text forms-authoring-input bg-transparent max-w-[800px]`}
                style={component.styles}
                type="text"
            />
        </div>
    );
}

export default AutoField;